<!--
 * @Autor: 毛萍萍
 * @Date: 2021-09-01 10:07:33
 * @LastEditTime: 2021-09-01 14:45:56
 * @LastEditors: 毛萍萍
 * @Description: 列表搜索保存当前搜索结果弹出框
 * @FilePath: \scim-edm-web\src\views\standard\material-manage\material-info\list\save-search-filter.vue
-->
<template>
  <el-dialog
    :key="formKey"
    :title="$t('common.addSearchResult')"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    class="self-dialog-form dialog-form"
    width="460px"
  >
    <el-form ref="formRef" :rules="formRules" :model="formData" @submit.native.prevent>
      <el-form-item :label="$t('common.searchContitionName')" prop="name">
        <el-input v-model="formData.name" :placeholder="$t('common.searchContitionName')" autocomplete="off" :max-length="10" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button plain @click="dialogVisible = false">{{ $t('public.cancel') }}</el-button>
      <el-button type="primary" @click="handleConfirm">{{ $t('public.confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "SaveSearchFilter",
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formKey: new Date().getTime(),
      formData: {
        name: ""
      },
      formRules: {
        name: [
          { required: true, message: `${this.$t("common.pleaseEnter")}${this.$t("common.searchContitionName")}`, trigger: "blur" }
        ]
      }
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    }
  },
  methods: {
    handleConfirm() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          this.dialogVisible = false;
          this.$emit("confirm", this.formData.name);
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
</style>
